/* eslint-disable @typescript-eslint/no-deprecated */

import React, { FC } from 'react'
import styled from 'styled-components'
import { hexAlpha } from '../../utils'
import { Button } from '../Button'
import { Body, SubHeading } from '../Typography'
import { Box } from '../Box'

interface NoResultsMessageProps {
  heading: string
  body: string
  button?: {
    text: string
    onClick: () => void
  }
}

export const NoResultsMessage: FC<NoResultsMessageProps> = ({ heading, body, button }) => {
  return (
    <FlexCenter>
      <BoxWithShadow>
        <SubHeading>{heading}</SubHeading>
        <Body>{body}</Body>
        {button && (
          <ResetButtonWrapper>
            <Button onClick={button.onClick}>{button.text}</Button>
          </ResetButtonWrapper>
        )}
      </BoxWithShadow>
    </FlexCenter>
  )
}

const BoxWithShadow = styled(Box)`
  box-shadow: 0 3px 12px 0 ${({ theme }) => hexAlpha(theme.colors.dark, 0.15)};
  max-width: 100%;
  text-align: center;
`

const FlexCenter = styled.div`
  padding-top: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
`

const ResetButtonWrapper = styled.div`
  padding-top: 2rem;
`
